import { memo, FC } from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import animate from "./animate.json";
import { mapIsWutian } from "store/reducers/theme";
import { useSelector } from "react-redux";

import cs from "classnames";
import styles from "./index.module.scss";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const wutianSpin = <LoadingOutlined spin className={styles.wutianSpin} />;

interface ILoading {}

const Loading: FC<ILoading> = () => {
  const isWutian = useSelector(mapIsWutian);
  return (
    <div className={styles.root}>
      {isWutian ? (
        <Spin indicator={wutianSpin} />
      ) : (
        <Player
          autoplay
          loop
          src={animate}
          className={cs(styles.animate)}
        ></Player>
      )}
    </div>
  );
};

export default memo(Loading);
